import { gql } from "@apollo/client";

export const ADD_UPDATE_CLAN_FAQS = gql`
  mutation addUpdateClanFaqs(
    $accountId: Int
    $roleId: Int
    $faqValue: String!
    $faqParameter: String!
    $faqId: Int
    $status: Int
    $faqLabel: String!
  ) {
    addUpdateClanFaqs(
      accountId: $accountId
      roleId: $roleId
      faqValue: $faqValue
      faqParameter: $faqParameter
      faqId: $faqId
      faqLabel: $faqLabel
      status: $status
    ) {
      success
      message
      data {
        id
        lang
        accountId
        roleIds
        faqtype
        faqParameter
        faqValue
        status
      }
    }
  }
`;
